<template>
  <div class="sidebar">
    <!-- <div>
      <div
        class="tab"
        :class="{ 'son-hover': path == '/networksindex' }"
      >
        <div
          class="box"
          @click="networksindex()"
          style="display: flex;align-items: center;"
        >
          <img class="img" src="../assets/img/computer.png">
          <div class="img iconfont icon-diannao"></div>
          概览
        </div>
      </div>
    </div> -->
    <div
      v-for="(item, index) in tabList"
      :key="item.id"
    >
      <div
        class="tab"
        :class="{ 'tab-hover': xshicd }"
      >
        <div
          class="box"
          @click="img(item.id, xshicd, index, item)"
          style="display: flex;align-items: center;"
        >
          <!-- <img class="img" :src="item.src"> -->
          <div
            class="img"
            :class="{ [item.adminMenuIcon]: true }"
          ></div>
          {{ item.adminMenuName }}
          <div
            :class="item.gbcdjtzt === true ? 'jtzkai' : 'jtshou'"
            v-if="item.children.length>0"
            class="down-img iconfont icon-iconfontzhizuobiaozhun023129"
          >
          </div>
        </div>
        <div
          class="sonbox"
          :style="item.gbcdjtzt=== true ? `height:${item.children.length * 55}px` : 'height:0px' "
        >
          <div
            @click="changepage(s.id, s.adminMenuURL,s.adminMenuPID)"
            :class="{ 'son-hover': s.id == id }"
            class="son-box"
            v-for="s in item.children"
            :key="s.id"
          >
            {{ s.adminMenuName }}
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="isuper == 'manager'">
      <div
        class="tab"
        :class="{ 'son-hover': path == '/Userdata' }"
      >
        <div
          class="box"
          @click="userList()"
          style="display: flex;align-items: center;"
        >
          <div class="img iconfont el-icon-user"></div>
          子账号管理
        </div>
      </div>
    </div> -->
    <!-- <div v-if="isuper == 'manager'">
      <div
        class="tab"
        :class="{ 'son-hover': path == '/Admindata' }"
      >
        <div
          class="box"
          @click="adminList()"
          style="display: flex;align-items: center;"
        >
          <div class="img iconfont icon-shezhi"></div>
          管理员管理
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: '1',
      path: '1',
      isuper: '',
      sonid: '',
      xshicd: true,
      cdid: 0,
      tabList: [],
      // fuserList: []
    }
  },
  created() {
    let tabid = sessionStorage.getItem('tabid');
    let path = sessionStorage.getItem('path');
    let tabList = JSON.parse(sessionStorage.getItem('tabList'));
    let data = JSON.parse(sessionStorage.getItem('user'));
    this.isuper = data.issuper
    this.id = tabid ? tabid : '1'
    this.path = path ? path : '/networksindex'
    this.tabList = tabList ? tabList : this.tabList

  },
  mounted() {
    this.selectuser();    
  },
  methods: {
    // 箭头旋转
    img(id, show, index, sars) {

      if (sars.children.length > 0) {
        // if (show == false && (id == 'ebab5d96-997b-422a-ba65-790c0ecc3c81' || id == '3f2ab5b9-b183-4e57-aa26-454f42b2eeaf')) {
        //   this.tabList[index].show = true
        // } else {
        //   this.tabList[index].show = false
        // }
        //this.xshicd = false;
        // for (let k = 0; k < this.tabList.length; k++) {
        //   if (this.tabList[k].id == id) {
        //     this.$nextTick(() => { this.tabList[k].show = true })

        //   }
        // }
        //this.tabList[index].show = true
        // if (this.xshicd == true) {
        //   this.xshicd = false
        // } else {
        //   this.xshicd = true
        // }
        // if (this.cdid !== id) {
        //   this.cdid = id;
        // } else {
        //   this.cdid = 0;
        // }
        for (let k = 0; k < this.tabList.length; k++) {
          if (id === this.tabList[k].id) {
            //this.tabList[k].gbcdjtzt = true;
            if (this.tabList[k].gbcdjtzt == true) {
              this.tabList[k].gbcdjtzt = false
            } else {
              this.tabList[k].gbcdjtzt = true
            }
            // console.log(this.tabList);
          }
        }
      } else {
        this.id = id
        //this.path = path
        sessionStorage.setItem('tabList', JSON.stringify(this.tabList));
        sessionStorage.setItem('tabid', this.id);
        sessionStorage.setItem('path', sars.url);
        this.$js.openpages(sars.url);

      }
      // this.id = id
    },
    // 跳转
    changepage(id, path, fid) {      
      this.id = id
      this.path = path
      sessionStorage.setItem('tabList', JSON.stringify(this.tabList));
      sessionStorage.setItem('tabid', this.id);
      sessionStorage.setItem('path', this.path);
      //console.log('111');
      //console.log(path);
      this.$js.openpages(path);
      // for (let k = 0; k < this.tabList.length; k++) {
      //   if (this.tabList[k].id == fid) {
      //     this.img(this.tabList[k].id, this.tabList[k].show, k, this.tabList[k]);
      //     console.log('111');
      //     console.log(this.tabList[k].id);
      //     console.log(fid);
      //     console.log(this.tabList[k].show);
      //     if (this.tabList[k].show == true) {
      //       this.tabList[k].show = false
      //     } else {
      //       this.tabList[k].show = true
      //     }
      //   }
      // }
    },
    // 概览跳转
    networksindex() {
      this.id = 1
      this.path = '/networksindex'
      sessionStorage.setItem('tabList', JSON.stringify(this.tabList));
      sessionStorage.setItem('tabid', this.id);
      sessionStorage.setItem('path', this.path);
      this.$js.openpages('/networksindex')
    },
    // 子账号跳转
    userList() {
      this.id = 8
      this.path = '/Userdata'
      sessionStorage.setItem('tabList', JSON.stringify(this.tabList));
      sessionStorage.setItem('tabid', this.id);
      sessionStorage.setItem('path', this.path);
      this.$js.openpages('/Userdata');
    },
    // 管理员跳转
    adminList() {
      this.id = 9
      this.path = '/Admindata'
      sessionStorage.setItem('tabList', JSON.stringify(this.tabList));
      sessionStorage.setItem('tabid', this.id);
      sessionStorage.setItem('path', this.path);
      this.$js.openpages('/Admindata');
    },
    listToTree(list) {
      let map = {}, node, tree = [], i;
      for (i = 0; i < list.length; i++) {
        map[list[i].id] = i; // 初始化映射
        list[i].children = []; // 初始化children数组
        //list[i].show = false;
      }
      for (i = 0; i < list.length; i++) {
        node = list[i];
        if (node.adminMenuPID !== "*") { // 如果当前节点的parentId不是根节点的parentId，即不是根节点
          // 找到当前节点的父节点
          list[map[node.adminMenuPID]].children.push(node);
          if (this.$route.path === list[i].adminMenuURL) {
            list[map[node.adminMenuPID]].gbcdjtzt = true;
          }
        } else {
          tree.push(node); // 如果当前节点是根节点，将其添加到树结构中
        }
      }
      return tree;
    },
    //查询用户信息
    async selectuser() {
      let Memberslen = 0
      let networkslen = 0
      let id = JSON.parse(sessionStorage.getItem('user')).id
      let issuper = JSON.parse(sessionStorage.getItem('user')).issuper
      //let res = await this.$apiFun.selectadmin({ id, issuper });
      // let rejs = await this.$apiFun.selectrole({ id });
      let res = await this.$apiFun.selectmenu({ id });
      sessionStorage.setItem('menu', JSON.stringify(res));
      // this.orgList.push({
      //   id: 1,
      //   name: '顶级菜单',
      //   children: []
      // });
      // this.orgList[0].children = this.listToTree(res);
      //console.log('11111');
      //console.log(res);
      let listjs = [];//获取授权的菜单id

      // rejs.forEach(item => {
      //   if (item.adminRoleName == issuper) {
      //     //listjs = item.yjqx.split(",");
      //     if (item.adminRoleMenu != null) {
      //       listjs = JSON.parse(item.adminRoleMenu);
      //     }
      //   }
      // })


      //console.log(jsarr.length, (jsarr.length - 1));
      //console.log('44444');
      //console.log(jsarr);


      let jsarrr = Array.from(new Set(res.map(item => JSON.stringify(item)))).map(item => JSON.parse(item));//去重复
      //console.log('33333');
      //console.log(jsarr);
      let datacd = jsarrr.sort((a, b) => a.adminMenuSortcd - b.adminMenuSortcd);//排序
      //console.log('444');
      //console.log(this.tabList);
      for (let j = 0; j < datacd.length; j++) {
        datacd[j].gbcdjtzt = false;
      }
      // for (let i = 0; i < datacd.length; i++) {
      //   if (this.$route.path === datacd[i].adminMenuURL) {
      //     datacd[i].gbcdjtzt = true;
      //   }
      // }
      //console.log(datacd);
      this.tabList = this.listToTree(datacd);
      //console.log(listjs);
      //console.log(lsdata);
      //console.log(jsarr);
      //console.log(this.tabList);

      //console.log(datacd);

      if (res == false) {
        //console.log(res);
      } else {
        this.userList = res
        this.fuserList = this.userList
      }
    },
  }
}
</script>

<style scoped>
.sonbox {
  height: 0px;
  overflow: hidden;
  transition: height 0.2s;
}

.sidebar {
  /* position: absolute; */
  /* z-index: 999; */
  font-size: 14px;
  color: #ffffff;
  height: 100%;
  /* height: calc(100% - 70px); */
  width: 200px;
  /* background-color: white; */
  background-color: #003450;
  overflow: auto;
  flex-shrink: 0;
}

.sidebar2 {
  position: absolute;
  z-index: 999;
  font-size: 14px;
  color: #ffffff;
  height: 100%;
  width: 54px;
  background-color: #304156;
  overflow: auto;
}

.img {
  margin: 0px 25px 0 19px;
  font-size: 20px;
}

.imgshow {
  position: fixed;
  z-index: 9999;
  display: flex;
  align-items: center;
  margin-left: 10px;
  width: 50px;
  height: 50px;
  left: 210px;
  color: black;
}

.imgshowbox {
  font-size: 25px;
  cursor: pointer;
}

.tab {
  position: relative;
  line-height: 50px;
  width: 100%;
  /* text-align: center; */
  /* color: #5F6368; */
  color: #fff;
  cursor: pointer;
  align-items: center;
}

.down-img {
  position: absolute;
  right: 30px;
  top: 0px;
  font-size: 10px;
  transition: 0.3s;
}

.son-box {
  height: 50px;
  line-height: 50px;
  margin-bottom: 5px;
  color: #fff;
  background-color: #003450;
  padding-left: 75px;
  /* color: #5F6368; */
}

.son-hover {
  color: #fff;
  background: #1677ff;
}

.son-box:hover {
  color: #fff;
  background: #1677ff;
}

.box:hover {
  /* color: #012f55; */
  /* background-color: #1677ff; */
}

.box {
  white-space: nowrap;
}

.tab-hover {
  /* color: #012f55; */
  /* color: rgb(64, 158, 255); */
}

.jtzkai {
  transform: rotate(-180deg);
}
.jtshou {
  transform: rotate(0deg);
}
</style>